import React from 'react';
import { Col, Row, Select } from 'antd';
import { useFormikContext } from 'formik';
import _get from 'lodash/get';

import { useEthnicityList } from 'api/mappings';
import { TRuleCreatePage } from 'containers/Rule/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

const Race: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const { data: ethnicities = [] } = useEthnicityList();

  const { t } = useMultiLanguageTranslation();

  return (
    <>
      <Row gutter={8}>
        <Col span={6}>
          <Select
            value={_get(values, 'filters.race[0].criteria[0].policy')}
            onSelect={value => {
              setFieldValue('filters.race[0].criteria[0].policy', value);
            }}
            placeholder={t(
              `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.EthnicityFilter.Includes`
            )}
            data-testid="race-include-select"
          >
            <Select.Option value="include" data-testid="race-include-select-include">
              {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.EthnicityFilter.Includes`)}
            </Select.Option>
            <Select.Option value="exclude" data-testid="race-include-select-exclude">
              {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.EthnicityFilter.Excludes`)}
            </Select.Option>
          </Select>
        </Col>
        <Col span={18}>
          <Select
            mode="multiple"
            showArrow
            allowClear
            value={_get(values, 'filters.race[0].criteria[0].values')}
            onChange={values => {
              setFieldValue('filters.race[0].criteria[0].values', values);
            }}
            filterOption={(inputValue, option) =>
              (option.props.children as string).toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
            placeholder={t(
              `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.EthnicityFilter.SelectEthnicity`
            )}
          >
            {ethnicities?.map(race => (
              <Select.Option key={race.id} value={race.id}>
                {race.name}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
    </>
  );
};

export default Race;
